// Search
export const GET_SEARCH_PARAMS = 'GET_SEARCH_PARAMS';
export const GET_SEARCH_RES = 'GET_SEARCH_RES';
export const UPDATE_BUS = 'UPDATE_BUS';
export const UPDATE_FILTER_TIME = 'UPDATE_FILTER_TIME';
export const UPDATE_FILTER_COACH = 'UPDATE_FILTER_COACH';
export const UPDATE_FILTER_AMEN = 'UPDATE_FILTER_AMEN';
export const UPDATE_FILTER_RESET = 'UPDATE_FILTER_RESET';
export const UPDATE_SEAT_CHART = 'UPDATE_SEAT_CHART';
export const UPDATE_SEAT_CHART_DET = 'UPDATE_SEAT_CHART_DET';

export const UPDATE_CHECKOUT_DET = 'UPDATE_CHECKOUT_DET';
export const UPDATE_USER_NAME = 'UPDATE_USER_NAME';
export const UPDATE_USER_AGE = 'UPDATE_USER_AGE';
export const UPDATE_USER_GENDER = 'UPDATE_USER_GENDER';